import Vue from "vue";
import VueI18n from "vue-i18n";
import { numberFormats } from "./numberFormats";
import axios from "axios";
/*
import en from "./translation/en.json";
import de from "./translation/de.json";
const messages = Object.assign({
  en: en,
  de: de
});*/

export const PREFIX = {
  PO: "po_",
  PP: "pp_",
  POV: "pov_"
};

var loadedDefaults = false;

export const addDefaultTranslations = (options, productparts) => {
  var poTranslate = {};
  for (var option in options) {
    poTranslate[PREFIX.PO + options[option].label] = options[option].label;
    for (var value in options[option].values) {
      if (!poTranslate[PREFIX.POV + options[option].values[value].label]) {
        poTranslate[PREFIX.POV + options[option].values[value].label] =
          options[option].values[value].label;
      }
    }
  }

  for (var pp in productparts) {
    poTranslate[PREFIX.PP + productparts[pp].label] = productparts[pp].label;
    for (var po in productparts[pp].page_options) {
      poTranslate[PREFIX.PO + productparts[pp].page_options[po].label] =
        productparts[pp].page_options[po].label;
      for (var value in productparts[pp].page_options[po].values) {
        if (
          !poTranslate[
            PREFIX.POV + productparts[pp].page_options[po].values[value].label
          ]
        ) {
          poTranslate[
            PREFIX.POV + productparts[pp].page_options[po].values[value].label
          ] = productparts[pp].page_options[po].values[value].label;
        }
      }
    }
  }

  var loadedLocale = i18n.getLocaleMessage(i18n.locale);
  i18n.setLocaleMessage(i18n.locale, {
    ...poTranslate,
    ...loadedLocale
  });
  loadedDefaults = true;
};

export const setLanguageAttributes = language => {
  if (language.lang) {
    i18n.locale = language.lang;
  }
  if (language.fallback) {
    i18n.fallback = language.fallback;
  }

  if (language.translations) {
    if (loadedDefaults) {
      i18n.mergeLocaleMessage(i18n.locale, language.translations);
    } else {
      i18n.setLocaleMessage(i18n.locale, language.translations);
    }
  } else if (language.files) {
    var axiosRequests = [];
    var langIndex = {};
    var counter = 0;
    for (var lang in language.files) {
      axiosRequests.push(axios.get(language.files[lang]));
      langIndex[counter++] = lang;
    }

    axios
      .all(axiosRequests)
      .then(
        axios.spread((...responses) => {
          for (var response in responses) {
            if (langIndex[response] == i18n.locale && loadedDefaults) {
              i18n.mergeLocaleMessage(
                langIndex[response],
                responses[response].data
              );
            } else {
              i18n.setLocaleMessage(
                langIndex[response],
                responses[response].data
              );
            }
          }
        })
      )
      .catch(errors => {
        console.log("Can not get language file ");
        console.log(errors);
      });
  }
};

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: "de",
  fallbackLocale: "de",
  formatFallbackMessages: true,
  //messages,
  numberFormats,
  silentTranslationWarn: true
});
